export const preferenceKeys = {
	index: ["preferences"],
};
